import axios from 'axios';
import { baseUrl } from "../common/siteSettings";
import heyapi from "../middleware/axiosInstance";

// Get all email logs with pagination and filtering
export const getAllEmailLogs = async (page = 1, limit = 10, status = null, emailType = null, token) => {
    try {
        let url = `/admin/logs/mails?page=${page}&limit=${limit}`;
        
        if(status) {
            url += `&status=${status}`;
        }
        
        if(emailType) {
            url += `&emailType=${emailType}`;
        }
        
        const response = await heyapi.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    }
    catch (err) {
        console.log(err);
    }
}

// Get email log details by id
export const getEmailLogDetails = async (emailLogId, token) => {
    try {
        const response = await heyapi.get(`/admin/logs/mails/${emailLogId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    }
    catch (err) {
        console.log(err);
    }
}
